<template>
  <input
    type="text"
    class="form-control text-center text-lg-left"
    ref="timePicker"
    v-model="mutableValue"
    :class="{'disabled-input': disabled}"
  />
</template>

<script>
import flatpickr from 'flatpickr';
import {localeToSelect} from '../../common/flatpickrlocalizer';

export default {
  props: ['value', 'disabled'],
  data() {
    return {
      picker: null,
      mutableValue: this.value,
    };
  },
  watch: {
    disabled() {
      if (!this.disabled) {
        $(this.$refs.timePicker)
          .siblings(".disabled-input")
          .removeClass("disabled-input");
      }
    },
    mutableValue(newValue) {
      this.$emit('input', newValue);
    },
    value(newValue) {
      this.picker && this.picker.setDate(newValue, true);
    },
  },
  mounted() {
    if (!this.picker) {
      this.picker = flatpickr(this.$refs.timePicker, {
        enableTime: true,
        noCalendar: true,
        time_24hr: true,
        dateFormat: 'H:i',
        defaultDate: '09:00',
        locale: localeToSelect,
      });
    }
  },
  beforeDestroy() {
    if (this.picker) {
      this.picker.destroy();
      this.picker = null;
    }
  },
};
</script>
<style>
.flatpickr-mobile{
  height: 44px;
  line-height: 40px;
  padding: initial !important;
}
</style>
